import React, { FC, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAptorApi } from '../../../../../../Api';
import { IGridQueryRequest } from '../../../../../../Api/AptorApi';
import { CompanyUnits, ICompanyUnit } from '../../CompanyUnits.List';

export const LawCompanyUnits: FC<{ lawId: number }> = ({ lawId }) => {
  const { api } = useAptorApi();
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/law-portal/settings')
    ? `/law-portal/settings/legal-list/${lawId}`
    : `/organization/law-portal/laws/${lawId}`;
  
  const dataFetcher = useCallback(
    (request: IGridQueryRequest) => api.searchLawCompanyUnits<ICompanyUnit>(lawId, request),
    [lawId, api],
  );

  return (
    <CompanyUnits
      addLink={`${basePath}/company-units/new`}
      dataFetcher={dataFetcher}
      edit={(id: number) => navigate(`${basePath}/company-units/${id}`)}
      remove={(id: number) => api.removeLawCompanyUnit(lawId, id)}
    />
  );
};